import React from 'react'
import PropTypes from 'prop-types';
import Page from 'components/Page';
import InfoBar from "components/complex/infobar/InfoBar";
import {makeStyles} from "@material-ui/styles";
import PurchaserScenesRouter from "./PurchaserScenesRouter";
import DemandOffersService from "../../../../services/DemandOffersService";
import {connect} from "react-redux";
import StageBar from "../../../../components/complex/stagebar/StageBar";
import ContractorStageBar from "../../../../components/complex/stagebar/ContractorStageBar";


const useStyles = makeStyles(theme => ({
    content: {
        padding: theme.spacing(2)
    }
}));

function PurchaserStepperPages(
    {
        match,
        demandStagesList
    }) {
    const classes = useStyles();
    return (

        <Page>
            <InfoBar />
            <StageBar />
            <ContractorStageBar demandStagesList={demandStagesList} />
            <div className={classes.content}>
                <PurchaserScenesRouter/>
            </div>
        </Page>
    )
}

PurchaserStepperPages.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    //inicjalizowane są w konkretntm kontekście, np: nie będzie dla korespondencji, inne będą dla oferty wykonawcy a inne dla postępowania wieloetapowego
    demandStagesList: state.resources[DemandOffersService.DEMAND_STAGES_LIST]
}), {})(PurchaserStepperPages);

